module.exports = __webpack_public_path__ + "statics/img/cate1-5@2x.69f2193e.png";